<template>
  <div class="awards-list">
    <el-table
      ref="multipleTable"
      :data="medalList"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      class="common-edit-button"
    >
      <el-table-column label="#" type="index"> </el-table-column>
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        prop="studentName"
        label="姓名"
        width="120px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="competitionName"
        label="比赛名称"
        width="160px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="medal"
        label="奖项"
        width="150px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="schoolYear"
        label="学年"
        width="150px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="semester"
        label="学期"
        width="150px"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row.semester == "2" ? "第二学期" : "第一学期" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="presentationUnit"
        label="颁奖单位"
        width="150px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="gradeClass"
        label="年级班级"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row.gradeName }}{{ scope.row.className }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="185px">
        <template slot-scope="scope">
          <div class="handle-container">
            <!-- 修改 -->
            <!-- <el-button
                type="primary"
                icon="el-icon-edit"
                :disabled="classInfo.currentClass.isCharge != 1"
                @click="editClick(scope.row)"
              >
              </el-button> -->
            <!-- 删除 -->
            <!-- 详情 -->
            <el-button
              type="success"
              icon="el-icon-info"
              @click="detailClick(scope.row)"
              v-hasPermi="'sc:medal:query'"
              size="small"
            >详情
            </el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="deleteClick(scope.row)"
              v-hasPermi="'sc:medal:delete'"
              size="small"
            >删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 调课详情 -->
    <awardsDetail
      :medalDetail="medalDetail"
      :detailShow.sync="detailShow"
      v-if="detailShow"
    />
  </div>
</template>

<script>
import awardsDetail from "../awards-detail/awardsDetail.vue";
export default {
  components: {
    awardsDetail,
  },
  data() {
    return {
      title: "",
      medalDetail: {},
      detailShow: false,
    };
  },
  inject: ["refresh"],
  props: {
    medalList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    handleSelectionChange(val) {
      // console.log(val);
      this.selectList = val;
      let list = [];
      this.selectList.forEach((item) => {
        list.push(item.id);
      });
      this.$emit("multipleDelete", list);
    },
    detailClick(item) {
      this.get(this.$url.getMedalDetail + "/" + item.id).then((res) => {
        this.medalDetail = res.data;
        this.detailShow = true;
      });
    },
    // 点击删除
    deleteClick(item) {
      // console.log(item);
      this.$confirm("是否删除该获奖信息?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除学生信息接口
          let list = [];
          list.push(item.id);
          this.delete(this.$url.delMedal + "/" + list)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              // console.log(err);
              // this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
@import "./awardsList.scss";
</style>
